(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skate-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-skate-builder]');
    if (!root) return;

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const value = parts.join('.');
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
    };

    const formatDelta = (cents) => {
      if (cents === 0) return formatMoney(0);
      const sign = cents > 0 ? '+' : '−';
      return sign + formatMoney(Math.abs(cents));
    };

    const stepIds = [];
    const stepRoles = {};
    const stepElems = {};
    root.querySelectorAll('[data-skate-builder-step]').forEach((el) => {
      const id = el.dataset.skateBuilderStep;
      stepIds.push(id);
      stepRoles[id] = el.dataset.stepRole || 'generic';
      stepElems[id] = el;
    });

    const findBaseId = () => stepIds.find((id) => stepRoles[id] === 'base') || stepIds[0];
    const baseId = findBaseId();
    const isBase = (id) => id === baseId;

    const state = {};
    const emptyState = () => ({ product: null, variant: null, size: null, isDefault: false, isNone: false });
    stepIds.forEach((id) => {
      state[id] = emptyState();
    });

    // The part that comes with the selected skate for a role, if the skate's
    // custom.default_<role> metafield points at a readable product.
    const defaultFor = (id) => {
      const base = state[baseId].product;
      const d = base && base.defaults && base.defaults[stepRoles[id]];
      return d && d.handle ? d : null;
    };
    const isDefaultProduct = (id, product) => {
      const d = defaultFor(id);
      return !!(d && product && d.handle === product.handle);
    };
    // A skate can ship with nothing in a slot (the old builder's "No Wheels"
    // default on anti-rocker setups): the skate's custom.ships_without list
    // arrives as `none_defaults`, and the step pre-selects its None option.
    const noneDefaultFor = (id) => {
      const base = state[baseId].product;
      const list = base && base.stockValues && base.stockValues.none_defaults;
      return Array.isArray(list) && list.indexOf(stepRoles[id]) !== -1;
    };
    const NONE_HANDLE = '__none__';
    const stepLabelFor = (id) => {
      const item = summaryItems[id] && summaryItems[id].querySelector('.skate-builder__summary-label');
      const label = item ? item.textContent.trim() : (stepRoles[id] || 'part').replace(/_/g, ' ');
      return label.charAt(0).toLowerCase() + label.slice(1);
    };
    let activeStep = stepIds[0];
    let allBrands = new Set();
    let activeBrand = null;

    const stepBtns = {};
    root.querySelectorAll('[data-step-btn]').forEach((b) => {
      stepBtns[b.dataset.stepBtn] = b;
    });

    const summaryItems = {};
    root.querySelectorAll('[data-summary-item]').forEach((el) => {
      summaryItems[el.dataset.summaryItem] = el;
    });

    // Each step's size options panel, rendered in the pinned step bar.
    const variantPanels = {};
    root.querySelectorAll('[data-step-variant]').forEach((el) => {
      variantPanels[el.dataset.stepVariant] = el;
    });
    const variantOptionsFor = (id) => variantPanels[id] && variantPanels[id].querySelector('[data-variant-options]');

    const grandTotalEl = root.querySelector('[data-grand-total]');
    const minNoteEl = root.querySelector('[data-min-price-note]');
    const cartFieldsEl = root.querySelector('[data-cart-fields]');
    const submitBtn = root.querySelector('[data-skate-builder-submit]');
    const formEl = root.querySelector('[data-skate-builder-form]');
    const filtersEl = root.querySelector('[data-skate-builder-filters]');
    const brandListEl = root.querySelector('[data-brand-filter-list]');
    const prevBtn = root.querySelector('[data-step-prev]');
    const nextBtn = root.querySelector('[data-step-next]');

    const makeBuildId = () => {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'build-' + Math.abs(Date.now() ^ (performance.now() * 1000 | 0)).toString(36);
    };

    // The selected base skate carries the value of its stock parts (in dollars)
    // in a metafield. A swapped part costs its own price minus the stock part it
    // replaces, matching the live builder's differential pricing. Returns cents.
    const rawStockValue = (id) => {
      if (isBase(id)) return 0;
      const sv = state[baseId].product && state[baseId].product.stockValues;
      if (!sv) return 0;
      const dollars = sv[stepRoles[id]];
      return typeof dollars === 'number' && !Number.isNaN(dollars) ? Math.round(dollars * 100) : 0;
    };

    // Differential pricing is only offered when every stock part the base skate
    // declares can go into the cart as an "included" line (includedVariantFor,
    // defined below). Otherwise the skate sells at full retail in the summary
    // and in the cart alike, so what is shown and what is charged never differ.
    const pricingReady = () => {
      const base = state[baseId].product;
      if (!base || !base.stockValues) return false;
      if (!floorReady()) return false;
      return stepIds.every((id) => isBase(id) || rawStockValue(id) === 0 || !!includedVariantFor(id));
    };

    const stepStockValue = (id) => (pricingReady() ? rawStockValue(id) : 0);

    // The old builder never sells a skate under its minimum price (the
    // skate's custom.min_price, in dollars, arriving as stockValues.min_price):
    // a build below it is charged the minimum.
    const minPriceCents = () => {
      const sv = state[baseId].product && state[baseId].product.stockValues;
      const dollars = sv && sv.min_price;
      return typeof dollars === 'number' && !Number.isNaN(dollars) ? Math.round(dollars * 100) : 0;
    };

    // The minimum can only be charged if the adjustment variants exist
    // (adjustmentVariantFor below); without them the skate is not priced
    // differentially at all, so the shown and the charged price stay equal.
    const floorReady = () => {
      if (minPriceCents() === 0) return true;
      const adj = pricing.adjustmentVariants || {};
      return !!(adj['1.00'] && adj['0.01']);
    };

    // Net price a step contributes: base skate at its own price, every other
    // step as the differential against the stock part it replaces.
    const stepDelta = (id) => {
      const s = state[id];
      if (!s.product) return 0;
      // The default part is the stock part: keeping it costs nothing extra.
      if (!isBase(id) && s.isDefault) return 0;
      // No part at all: the whole stock value comes off, like the old
      // builder's "No Liners / No Frames / No Wheels / No Bearings".
      if (!isBase(id) && s.isNone) return 0 - stepStockValue(id);
      const rowPrice = s.variant ? s.variant.price : s.product.price;
      return isBase(id) ? rowPrice : rowPrice - stepStockValue(id);
    };

    const totalCents = () => {
      const base = state[baseId].variant ? state[baseId].variant.price : 0;
      let upgrades = 0;
      stepIds.forEach((id) => {
        if (isBase(id)) return;
        if (!state[id].product) return;
        upgrades += stepDelta(id);
      });
      const raw = base + upgrades;
      const floor = base && pricingReady() ? minPriceCents() : 0;
      const shortfall = Math.max(0, floor - raw);
      return { base, upgrades, floor, shortfall, total: raw + shortfall };
    };

    const updateLocks = () => {
      const baseReady = state[baseId].product && state[baseId].variant;
      stepIds.forEach((id) => {
        if (isBase(id)) return;
        const btn = stepBtns[id];
        if (btn) btn.dataset.locked = baseReady ? 'false' : 'true';
      });
      const onFinalStep = stepIds.indexOf(activeStep) === stepIds.length - 1;
      if (submitBtn) submitBtn.disabled = !baseReady || !onFinalStep;
      if (prevBtn) prevBtn.hidden = stepIds.indexOf(activeStep) === 0;
      if (nextBtn) nextBtn.hidden = onFinalStep;
      stepIds.forEach((id) => {
        const panel = variantPanels[id];
        if (panel) panel.hidden = !(id === activeStep && stepElems[id].dataset.hasVariant === 'true');
      });
    };

    const updateCartFields = () => {
      // Cart submission is handled via AJAX in the form submit listener.
    };

    // Included-variant ids rendered by Liquid (see the pricing note in the
    // markup). Missing product => empty map, and the cart falls back to
    // base + swapped parts only.
    const pricingEl = root.querySelector('[data-builder-pricing]');
    let pricing = { includedVariants: {}, adjustmentVariants: {} };
    try {
      if (pricingEl) pricing = Object.assign(pricing, JSON.parse(pricingEl.textContent));
    } catch (e) { /* keep defaults */ }

    // Cart lines that lift a build up to the skate's minimum price: whole
    // dollars as quantity of the $1.00 variant, the cents as one variant.
    const adjustmentLines = (shortfallCents, props) => {
      const adj = pricing.adjustmentVariants || {};
      const lines = [];
      const dollars = Math.floor(shortfallCents / 100);
      const cents = shortfallCents % 100;
      if (dollars > 0 && adj['1.00']) lines.push({ id: Number(adj['1.00']), quantity: dollars, properties: props });
      const centKey = (cents / 100).toFixed(2);
      if (cents > 0 && adj[centKey]) lines.push({ id: Number(adj[centKey]), quantity: 1, properties: props });
      return lines;
    };

    // The "included" variant that stands in for a step's stock part, keyed by
    // role and stock value ("liner:29.00"). Null when the base has no stock value
    // for the role or no matching variant exists.
    const includedVariantFor = (id) => {
      const cents = rawStockValue(id);
      if (!cents) return null;
      const key = (stepRoles[id] || 'generic') + ':' + (cents / 100).toFixed(2);
      return pricing.includedVariants[key] || null;
    };

    // Sum of the base skate's stock values, i.e. the credit the automatic
    // discount must take off the base line for the cart to net out.
    const expectedCreditCents = () => {
      if (!pricingReady()) return 0;
      return stepIds.reduce((sum, id) => sum + rawStockValue(id), 0);
    };

    const buildCartItems = (buildId) => {
      const items = [];
      const base = state[baseId];
      if (!base.product || !base.variant) return items;
      const hasStockValues = pricingReady();

      stepIds.forEach((id) => {
        const s = state[id];
        const props = {
          _skate_build: buildId,
          _skate_role: stepRoles[id] || 'generic',
        };
        // Nothing goes in the cart for a step with no part: the base skate's
        // credit already takes that stock value off.
        if (!isBase(id) && s.isNone) return;
        if (s.product && s.variant && !s.isDefault) {
          if (isBase(id) && s.product.image) {
            props._skate_image = s.product.image;
          }
          // The automatic discount is gated on `_skate_role = base`, so a
          // full-retail build (no stock values / no included variant) is tagged
          // `skate` instead and never gets the credit.
          if (isBase(id) && !hasStockValues) props._skate_role = 'skate';
          // Parts nest under the skate line (Shopify nested cart lines): the
          // cart, checkout and emails group them, and removing the skate
          // removes the whole build.
          const line = { id: Number(s.variant.id), quantity: 1, properties: props };
          if (!isBase(id)) line.parent_id = Number(base.variant.id);
          items.push(line);
          return;
        }
        if (isBase(id) || !hasStockValues) return;

        // Stock part kept (default or untouched): add it at its stock value so
        // the base skate's credit nets out, named after the part when known.
        const includedId = includedVariantFor(id);
        if (includedId) {
          const partName = s.isDefault && s.product ? s.product.title : 'Stock ' + (stepRoles[id] || 'part');
          props.Included = partName + ' (comes with the skate)';
          items.push({ id: Number(includedId), quantity: 1, properties: props, parent_id: Number(base.variant.id) });
        }
      });
      // Below the skate's minimum price: the difference is charged too.
      const { shortfall } = totalCents();
      if (hasStockValues && shortfall > 0) {
        adjustmentLines(shortfall, {
          _skate_build: buildId,
          _skate_role: 'minimum',
          Note: 'Minimum price for this skate',
        }).forEach((line) => items.push({ ...line, parent_id: Number(base.variant.id) }));
      }
      return items;
    };

    // The credit is applied by an automatic discount in the store (see the
    // pricing note in the markup). If it did not land on the base line — no
    // price-list row for this skate, app paused, plan lapsed — the build would
    // be charged full retail plus the included parts, so it is pulled back out
    // of the cart instead of sending the customer to checkout.
    const verifyCartPricing = async (buildId) => {
      const expected = expectedCreditCents();
      if (!expected) return null;
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const base = (cart.items || []).find((i) => (
        i.properties && i.properties._skate_build === buildId && i.properties._skate_role === 'base'
      ));
      if (!base) return 'base line not found in cart';
      const credited = (base.line_level_discount_allocations || []).reduce((sum, d) => sum + (d.amount || 0), 0);
      if (credited < expected) return 'credit on base line is ' + credited + ', expected ' + expected;
      return null;
    };

    const removeCartLines = async (added) => {
      const updates = {};
      // The parts are nested under the skate line, so removing the skate is
      // enough; the other keys are only a fallback.
      const items = added && added.items ? added.items : [];
      const baseLine = items.find((i) => i.properties && (i.properties._skate_role === 'base' || i.properties._skate_role === 'skate'));
      if (baseLine && baseLine.key) updates[baseLine.key] = 0;
      else items.forEach((i) => { if (i.key) updates[i.key] = 0; });
      if (!Object.keys(updates).length) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
    };

    const renderSummary = () => {
      const baseProduct = state[baseId].product;
      stepIds.forEach((id) => {
        const item = summaryItems[id];
        if (!item) return;
        const s = state[id];
        const nameEl = item.querySelector('[data-summary-name]');
        const sizeEl = item.querySelector('[data-summary-size]');
        const priceEl = item.querySelector('[data-summary-price]');
        const thumbEl = item.querySelector('[data-summary-thumb]');
        const removeBtn = item.querySelector('[data-summary-remove]');

        if (s.product) {
          nameEl.textContent = s.product.title;
          if (thumbEl) {
            const label = item.querySelector('.skate-builder__summary-label').textContent;
            thumbEl.innerHTML = s.product.image
              ? `<img src="${s.product.image}" alt="${s.product.title}" loading="lazy">`
              : `<span class="skate-builder__summary-placeholder">${s.isNone ? 'None' : label}</span>`;
          }
          if (sizeEl) {
            if (s.isDefault) {
              sizeEl.textContent = 'Comes with the skate';
              sizeEl.hidden = false;
            } else if (s.isNone) {
              sizeEl.hidden = true;
            } else if (s.size) {
              sizeEl.textContent = `Size: ${s.size}`;
              sizeEl.hidden = false;
            } else {
              sizeEl.hidden = true;
            }
          }
          if (isBase(id)) {
            priceEl.textContent = formatMoney(s.variant ? s.variant.price : s.product.price);
            priceEl.removeAttribute('data-delta');
          } else {
            const delta = stepDelta(id);
            priceEl.textContent = formatDelta(delta);
            priceEl.setAttribute('data-delta', delta > 0 ? 'positive' : delta < 0 ? 'negative' : 'zero');
          }
          // The default part is the stock part; there is nothing to clear.
          if (removeBtn) removeBtn.hidden = !!s.isDefault;
        } else {
          nameEl.textContent = isBase(id) ? 'Choose a skate' : 'Stock';
          if (sizeEl) sizeEl.hidden = true;
          if (thumbEl) {
            const label = item.querySelector('.skate-builder__summary-label').textContent;
            thumbEl.innerHTML = `<span class="skate-builder__summary-placeholder">${label}</span>`;
          }
          priceEl.textContent = '';
          priceEl.removeAttribute('data-delta');
          if (removeBtn) removeBtn.hidden = true;
        }
      });

      const { total, floor, shortfall } = totalCents();
      if (baseProduct) {
        grandTotalEl.textContent = formatMoney(total);
      } else {
        grandTotalEl.textContent = '—';
      }
      if (minNoteEl) {
        if (baseProduct && shortfall > 0) {
          minNoteEl.textContent = 'This skate has a minimum price of ' + formatMoney(floor) + ', so your build is priced at that minimum. Adding components makes more sense.';
          minNoteEl.hidden = false;
        } else {
          minNoteEl.hidden = true;
        }
      }

      stepIds.forEach((id) => {
        const btn = stepBtns[id];
        if (!btn) return;
        btn.dataset.complete = state[id].product ? 'true' : 'false';
      });

      updateNoneCards();
      updateCartFields();
    };

    const setActiveStep = (id) => {
      if (!stepElems[id]) return;
      const baseReady = state[baseId].product && state[baseId].variant;
      if (!isBase(id) && !baseReady) return;
      if (typeof clearStepMsg === 'function') clearStepMsg();
      activeStep = id;
      stepIds.forEach((sid) => {
        if (stepElems[sid]) stepElems[sid].dataset.active = sid === id ? 'true' : 'false';
        if (stepBtns[sid]) stepBtns[sid].dataset.active = sid === id ? 'true' : 'false';
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
      rebuildBrandFilter();
      updateLocks();
    };

    const rebuildBrandFilter = () => {
      if (!brandListEl) return;
      const stepEl = stepElems[activeStep];
      if (!stepEl) return;
      const dataNode = stepEl.querySelector('[data-step-products]');
      let products = [];
      try { products = JSON.parse(dataNode.textContent); } catch { products = []; }
      const brands = Array.from(new Set(products.map((p) => p.vendor).filter(Boolean))).sort();
      brandListEl.innerHTML = '';
      if (brands.length === 0) {
        brandListEl.innerHTML = '<p class="skate-builder__filter-empty">No brands available.</p>';
        return;
      }
      const allLabel = document.createElement('label');
      allLabel.className = 'skate-builder__filter-item';
      allLabel.innerHTML = `<input type="radio" name="sb-brand-${activeStep}" value="" ${activeBrand === null ? 'checked' : ''}> All brands`;
      brandListEl.appendChild(allLabel);
      brands.forEach((b) => {
        const label = document.createElement('label');
        label.className = 'skate-builder__filter-item';
        label.innerHTML = `<input type="radio" name="sb-brand-${activeStep}" value="${b}" ${activeBrand === b ? 'checked' : ''}> ${b}`;
        brandListEl.appendChild(label);
      });
      brandListEl.addEventListener('change', onBrandChange);
    };

    const onBrandChange = (e) => {
      const value = e.target.value;
      activeBrand = value || null;
      applyBrandFilter();
    };

    const applyBrandFilter = () => {
      const stepEl = stepElems[activeStep];
      if (!stepEl) return;
      stepEl.querySelectorAll('[data-card]').forEach((c) => {
        if (c.dataset.none === 'true') return;
        c.hidden = activeBrand && c.dataset.vendor !== activeBrand;
      });
    };

    const renderVariantOptions = (stepEl, stepId, productData) => {
      const wrap = variantOptionsFor(stepId);
      if (!wrap) return;
      wrap.innerHTML = '';
      const realVariants = (productData.variants || []).filter((v) => v.title && v.title !== 'Default Title');
      if (realVariants.length === 0) {
        stepEl.dataset.hasVariant = 'false';
        return;
      }
      stepEl.dataset.hasVariant = 'true';
      realVariants.forEach((v) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'skate-builder-step__variant-option';
        btn.textContent = v.title;
        btn.dataset.variantId = v.id;
        if (!v.available) btn.disabled = true;
        btn.addEventListener('click', () => {
          state[stepId].variant = v;
          state[stepId].size = v.title;
          wrap.querySelectorAll('button').forEach((b) => {
            b.dataset.selected = b.dataset.variantId === String(v.id) ? 'true' : 'false';
          });
          renderSummary();
          updateLocks();
        });
        wrap.appendChild(btn);
      });
      if (realVariants.length === 1) {
        const only = realVariants[0];
        state[stepId].variant = only;
        state[stepId].size = only.title;
        wrap.querySelector('button').dataset.selected = 'true';
      }
    };

    // Step-message helpers are defined before selectProduct so that the
    // preselect path (which runs during init and calls selectProduct) does not
    // hit clearStepMsg while it is still in the temporal dead zone.
    const stepMsgEl = root.querySelector('[data-step-msg]');
    let stepMsgTimer = null;
    const showStepMsg = (msg) => {
      if (!stepMsgEl) return;
      stepMsgEl.textContent = msg;
      stepMsgEl.dataset.visible = 'true';
      clearTimeout(stepMsgTimer);
      stepMsgTimer = setTimeout(() => { clearStepMsg(); }, 3200);
    };
    const clearStepMsg = () => {
      if (!stepMsgEl) return;
      stepMsgEl.dataset.visible = 'false';
      clearTimeout(stepMsgTimer);
    };

    const selectProduct = (stepEl, stepId, productData) => {
      if (typeof clearStepMsg === 'function') clearStepMsg();
      const asDefault = !isBase(stepId) && isDefaultProduct(stepId, productData);
      state[stepId].product = productData;
      state[stepId].variant = null;
      state[stepId].size = null;
      state[stepId].isDefault = asDefault;
      state[stepId].isNone = false;
      stepEl.querySelectorAll('[data-card]').forEach((card) => {
        card.dataset.selected = card.dataset.productHandle === productData.handle ? 'true' : 'false';
      });
      if (asDefault) {
        // The stock part ships in the skate's own size: nothing to pick.
        const wrap = variantOptionsFor(stepId);
        if (wrap) wrap.innerHTML = '';
        stepEl.dataset.hasVariant = 'false';
        state[stepId].size = 'Comes with the skate';
      } else {
        renderVariantOptions(stepEl, stepId, productData);
        if ((!productData.variants || productData.variants.length === 0 ||
            productData.variants.every((v) => !v.title || v.title === 'Default Title')) && productData.firstVariantId) {
          state[stepId].variant = { id: productData.firstVariantId, price: productData.price, title: 'Default Title' };
        }
      }
      // A new skate starts from its own stock parts, like the old builder
      // (which confirmed "you will lose any customizations" on a skate change).
      if (isBase(stepId)) applyDefaults(true);
      renderSummary();
      updateLocks();
    };

    // Cards for a skate's default parts. A default that is not in the step's
    // collection gets a card of its own, first in the grid, so it stays
    // visible and can be re-selected after trying an upgrade.
    const ensureDefaultCard = (stepEl, stepId, d) => {
      const grid = stepEl.querySelector('[data-step-grid]');
      if (!grid) return null;
      const regular = grid.querySelector('[data-card][data-product-handle="' + d.handle + '"]:not([data-injected-default])');
      if (regular) {
        grid.querySelectorAll('[data-card][data-injected-default][data-product-handle="' + d.handle + '"]').forEach((c) => c.remove());
        return regular;
      }
      let card = grid.querySelector('[data-card][data-injected-default][data-product-handle="' + d.handle + '"]');
      if (card) return card;
      card = document.createElement('button');
      card.type = 'button';
      card.className = 'skate-builder-card';
      card.dataset.card = 'true';
      card.dataset.productHandle = d.handle;
      card.dataset.vendor = d.vendor || '';
      card.dataset.injectedDefault = 'true';
      card.dataset.priceLabel = 'Included';
      card.innerHTML = `
        <span class="skate-builder-card__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        <div class="skate-builder-card__media">
          ${d.image ? `<img src="${d.image}" alt="${d.title}" loading="lazy">` : ''}
        </div>
        ${d.vendor ? `<span class="skate-builder-card__vendor">${d.vendor}</span>` : ''}
        <h3 class="skate-builder-card__title">${d.title}</h3>
        <span class="skate-builder-card__price">Included</span>
      `;
      card.addEventListener('click', () => {
        selectProduct(stepEl, stepId, { ...d, variants: [], priceDelta: 0 });
      });
      grid.prepend(card);
      return card;
    };

    // The "No <part>" option every part step offers, like the old builder's
    // "No Liners / No Frames / No Wheels / No Bearings": the step contributes
    // nothing to the cart and the skate's full stock value comes off.
    const selectNone = (stepEl, stepId, asDefault, render = true) => {
      if (typeof clearStepMsg === 'function') clearStepMsg();
      const title = 'No ' + stepLabelFor(stepId);
      state[stepId] = {
        product: { handle: NONE_HANDLE, title, price: 0, variants: [] },
        variant: { id: null, price: 0, title: 'Default Title' },
        size: asDefault ? 'Comes with the skate' : null,
        isDefault: !!asDefault,
        isNone: true,
      };
      stepEl.querySelectorAll('[data-card]').forEach((card) => {
        card.dataset.selected = card.dataset.none === 'true' ? 'true' : 'false';
      });
      const wrap = variantOptionsFor(stepId);
      if (wrap) wrap.innerHTML = '';
      stepEl.dataset.hasVariant = 'false';
      if (render) {
        renderSummary();
        updateLocks();
      }
    };

    const ensureNoneCard = (stepEl, stepId) => {
      const grid = stepEl.querySelector('[data-step-grid]');
      if (!grid) return null;
      let card = grid.querySelector('[data-card][data-none="true"]');
      if (card) return card;
      card = document.createElement('button');
      card.type = 'button';
      card.className = 'skate-builder-card';
      card.dataset.card = 'true';
      card.dataset.productHandle = NONE_HANDLE;
      card.dataset.none = 'true';
      card.dataset.vendor = '';
      card.innerHTML = `
        <span class="skate-builder-card__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
        <div class="skate-builder-card__media">
          <svg class="skate-builder-card__none-mark" viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9"/><line x1="5.5" y1="18.5" x2="18.5" y2="5.5"/></svg>
        </div>
        <h3 class="skate-builder-card__title">No ${stepLabelFor(stepId)}</h3>
        <span class="skate-builder-card__price">${formatMoney(0)}</span>
      `;
      card.addEventListener('click', () => {
        selectNone(stepEl, stepId, false);
      });
      grid.appendChild(card);
      return card;
    };

    // The None card shows what leaving the slot empty saves on the selected
    // skate; re-run whenever the skate (and so the stock values) can change.
    const updateNoneCards = () => {
      const baseReady = !!state[baseId].product;
      stepIds.forEach((id) => {
        if (isBase(id)) return;
        const stepEl = stepElems[id];
        const priceEl = stepEl && stepEl.querySelector('[data-card][data-none="true"] .skate-builder-card__price');
        if (!priceEl) return;
        const credit = baseReady ? stepStockValue(id) : 0;
        priceEl.textContent = credit > 0 ? formatDelta(0 - credit) : formatMoney(0);
        priceEl.dataset.sign = credit > 0 ? 'negative' : 'zero';
      });
    };

    // Pre-selects the parts that come with the selected skate (metafields
    // custom.default_<role>, or the None option for roles the skate lists in
    // stockValues.none_defaults). A part the customer chose on purpose is
    // kept; empty steps and a previous skate's defaults follow the new skate.
    // No default means the step simply stays unselected.
    const applyDefaults = (resetAll) => {
      stepIds.forEach((id) => {
        if (isBase(id)) return;
        const stepEl = stepElems[id];
        if (!stepEl) return;
        if (resetAll && state[id].product) {
          state[id] = emptyState();
          stepEl.querySelectorAll('[data-card]').forEach((c) => { c.dataset.selected = 'false'; });
          const vw = variantOptionsFor(id);
          if (vw) { vw.innerHTML = ''; stepEl.dataset.hasVariant = 'false'; }
        }
        const d = defaultFor(id);
        const noneDefault = !d && noneDefaultFor(id);
        stepEl.querySelectorAll('[data-card][data-injected-default]').forEach((c) => {
          if (!d || c.dataset.productHandle !== d.handle) c.remove();
        });
        stepEl.querySelectorAll('[data-card]').forEach((c) => {
          if (c.dataset.none === 'true') {
            c.dataset.default = noneDefault ? 'true' : 'false';
            return;
          }
          const isDef = !!(d && c.dataset.productHandle === d.handle);
          c.dataset.default = isDef ? 'true' : 'false';
          const priceEl = c.querySelector('.skate-builder-card__price');
          if (priceEl) priceEl.textContent = isDef ? 'Included' : (c.dataset.priceLabel || priceEl.textContent);
        });
        const s = state[id];
        if (s.product && !s.isDefault) return;
        if (!d) {
          if (noneDefault) {
            selectNone(stepEl, id, true, false);
            return;
          }
          if (s.isDefault) {
            state[id] = emptyState();
            stepEl.querySelectorAll('[data-card]').forEach((c) => { c.dataset.selected = 'false'; });
          }
          return;
        }
        ensureDefaultCard(stepEl, id, d);
        state[id] = { product: { ...d, variants: [] }, variant: null, size: 'Comes with the skate', isDefault: true, isNone: false };
        stepEl.querySelectorAll('[data-card]').forEach((c) => {
          c.dataset.selected = c.dataset.productHandle === d.handle ? 'true' : 'false';
        });
        const wrap = variantOptionsFor(id);
        if (wrap) wrap.innerHTML = '';
        stepEl.dataset.hasVariant = 'false';
      });
    };

    const initStep = (stepEl) => {
      const stepId = stepEl.dataset.skateBuilderStep;
      const dataNode = stepEl.querySelector('[data-step-products]');
      if (!dataNode) return;
      let products = [];
      try { products = JSON.parse(dataNode.textContent); } catch { products = []; }

      const grid = stepEl.querySelector('[data-step-grid]');
      const empty = stepEl.querySelector('[data-step-empty]');

      if (!products.length) {
        if (empty) empty.hidden = false;
        if (grid) grid.hidden = true;
        return;
      }

      products.forEach((p) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'skate-builder-card';
        card.dataset.card = 'true';
        card.dataset.productHandle = p.handle;
        card.dataset.vendor = p.vendor || '';
        card.dataset.priceLabel = formatMoney(p.price);
        const safeDesc = (p.description || '').replace(/</g, '&lt;');
        card.innerHTML = `
          <span class="skate-builder-card__check" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </span>
          <div class="skate-builder-card__media">
            ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy">` : ''}
            ${safeDesc ? `
              <button type="button" class="skate-builder-card__info" data-card-info aria-label="Product info" aria-expanded="false">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="8" r="0.6" fill="currentColor"/>
                </svg>
              </button>
              <div class="skate-builder-card__desc" data-card-desc role="tooltip">${safeDesc}</div>
            ` : ''}
          </div>
          ${p.vendor ? `<span class="skate-builder-card__vendor">${p.vendor}</span>` : ''}
          <h3 class="skate-builder-card__title">${p.title}</h3>
          <span class="skate-builder-card__price">${formatMoney(p.price)}</span>
        `;
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-card-info]') || e.target.closest('[data-card-desc]')) return;
          selectProduct(stepEl, stepId, { ...p, priceDelta: p.price });
        });
        const infoBtn = card.querySelector('[data-card-info]');
        const descEl = card.querySelector('[data-card-desc]');
        if (infoBtn && descEl) {
          const positionDesc = () => {
            const r = infoBtn.getBoundingClientRect();
            const margin = 8;
            descEl.style.visibility = 'hidden';
            descEl.style.opacity = '0';
            descEl.dataset.open = 'true';
            const dw = descEl.offsetWidth;
            const dh = descEl.offsetHeight;
            let left = r.right - dw;
            if (left < margin) left = margin;
            if (left + dw > window.innerWidth - margin) left = window.innerWidth - margin - dw;
            let top = r.bottom + 6;
            if (top + dh > window.innerHeight - margin) {
              const above = r.top - 6 - dh;
              if (above >= margin) top = above;
              else top = Math.max(margin, window.innerHeight - margin - dh);
            }
            descEl.style.left = left + 'px';
            descEl.style.top = top + 'px';
            descEl.style.visibility = '';
            descEl.style.opacity = '';
          };
          const openDesc = () => {
            grid.querySelectorAll('[data-card-desc][data-open="true"]').forEach((d) => {
              if (d !== descEl) d.dataset.open = 'false';
            });
            positionDesc();
            infoBtn.setAttribute('aria-expanded', 'true');
          };
          const closeDesc = () => {
            descEl.dataset.open = 'false';
            infoBtn.setAttribute('aria-expanded', 'false');
          };
          infoBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (descEl.dataset.open === 'true') closeDesc();
            else openDesc();
          });
          infoBtn.addEventListener('mouseenter', () => {
            if (matchMedia('(hover: hover)').matches) openDesc();
          });
          infoBtn.addEventListener('mouseleave', () => {
            if (matchMedia('(hover: hover)').matches) closeDesc();
          });
          descEl.addEventListener('mouseenter', () => {
            if (matchMedia('(hover: hover)').matches) openDesc();
          });
          descEl.addEventListener('mouseleave', () => {
            if (matchMedia('(hover: hover)').matches) closeDesc();
          });
          window.addEventListener('scroll', () => {
            if (descEl.dataset.open === 'true') positionDesc();
          }, true);
          window.addEventListener('resize', () => {
            if (descEl.dataset.open === 'true') positionDesc();
          });
        }
        grid.appendChild(card);
      });

      if (!isBase(stepId)) ensureNoneCard(stepEl, stepId);

      const urlPreselect = new URLSearchParams(window.location.search).get('preselect');
      const preselect = urlPreselect || root.dataset.preselectHandle;
      if (preselect && isBase(stepId)) {
        const match = products.find((p) => p.handle === preselect);
        if (match) {
          selectProduct(stepEl, stepId, { ...match, priceDelta: 0 });
        }
      }
    };

    Object.values(stepElems).forEach((el) => initStep(el));
    applyDefaults();

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-card-info]') || e.target.closest('[data-card-desc]')) return;
      root.querySelectorAll('[data-card-desc][data-open="true"]').forEach((d) => {
        d.dataset.open = 'false';
        const btn = d.parentElement && d.parentElement.querySelector('[data-card-info]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });

    const toastEl = root.querySelector('[data-skate-builder-toast]');
    let toastTimer = null;
    const showToast = (msg) => {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.hidden = false;
      requestAnimationFrame(() => { toastEl.dataset.visible = 'true'; });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        toastEl.dataset.visible = 'false';
        setTimeout(() => { toastEl.hidden = true; }, 250);
      }, 2400);
    };

    const missingSelectionFor = (id) => {
      const s = state[id];
      const stepEl = stepElems[id];
      if (!stepEl) return null;
      const role = stepRoles[id] || 'part';
      if (isBase(id)) {
        if (!s.product) return 'Please select a base skate to continue.';
        if (stepEl.dataset.hasVariant === 'true' && !s.variant) return 'Please pick a size for your base skate.';
        return null;
      }
      if (s.isNone) return null;
      if (s.product && stepEl.dataset.hasVariant === 'true' && !s.variant) {
        return 'Please pick a size or option for the selected ' + role.replace(/_/g, ' ') + '.';
      }
      return null;
    };

    const tryAdvance = (toId) => {
      const msg = missingSelectionFor(activeStep);
      if (msg) {
        showStepMsg(msg);
        return false;
      }
      clearStepMsg();
      setActiveStep(toId);
      return true;
    };

    root.querySelectorAll('[data-step-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.dataset.locked === 'true') {
          showToast('Choose a base skate first.');
          return;
        }
        const targetId = btn.dataset.stepBtn;
        if (stepIds.indexOf(targetId) > stepIds.indexOf(activeStep)) {
          tryAdvance(targetId);
        } else {
          setActiveStep(targetId);
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const i = stepIds.indexOf(activeStep);
        if (i > 0) setActiveStep(stepIds[i - 1]);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const i = stepIds.indexOf(activeStep);
        if (i < stepIds.length - 1) tryAdvance(stepIds[i + 1]);
      });
    }

    root.querySelectorAll('[data-summary-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.summaryRemove;
        state[id] = emptyState();
        const stepEl = stepElems[id];
        if (stepEl) {
          stepEl.querySelectorAll('[data-card]').forEach((c) => { c.dataset.selected = 'false'; });
          const vw = variantOptionsFor(id);
          if (vw) { vw.innerHTML = ''; stepEl.dataset.hasVariant = 'false'; }
        }
        if (isBase(id) && activeStep !== baseId) {
          setActiveStep(baseId);
        }
        // Clearing an upgrade puts the skate's own part back.
        applyDefaults();
        renderSummary();
        updateLocks();
      });
    });

    if (formEl) {
      formEl.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!state[baseId].product || !state[baseId].variant) {
          showToast('Please select a base skate first.');
          return;
        }
        // A part picked without its size would silently fall back to the
        // stock part in the cart while the summary shows the upgrade.
        const missing = stepIds.map(missingSelectionFor).find(Boolean);
        if (missing) {
          showToast(missing);
          return;
        }
        const buildId = makeBuildId();
        const items = buildCartItems(buildId);
        if (!items.length) return;

        submitBtn.disabled = true;
        const originalLabel = submitBtn.textContent;
        submitBtn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add to cart.');
          }
          const added = await res.json().catch(() => ({}));
          const problem = await verifyCartPricing(buildId);
          if (problem) {
            console.warn('[skate-builder] pricing check failed, build removed from cart: ' + problem);
            await removeCartLines(added);
            throw new Error('We could not price this build correctly. Please try again later or contact us.');
          }
          window.location.href = '/cart';
        } catch (err) {
          showToast(err.message || 'Something went wrong adding to cart.');
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
      });
    }

    const mobileFilterToggle = root.querySelector('[data-mobile-filter-toggle]');
    const mobileFilterClose = root.querySelector('[data-mobile-filter-close]');
    if (mobileFilterToggle) {
      mobileFilterToggle.addEventListener('click', () => {
        filtersEl.dataset.open = 'true';
      });
    }
    if (mobileFilterClose) {
      mobileFilterClose.addEventListener('click', () => {
        filtersEl.dataset.open = 'false';
      });
    }

    // On mobile the summary is a bottom sheet; the header toggles it open/closed
    // so the itemised build (base skate, components, sizes, total) is reachable.
    const summaryEl = root.querySelector('[data-skate-builder-summary]');
    const summaryToggle = root.querySelector('[data-summary-toggle]');
    if (summaryEl && summaryToggle) {
      summaryToggle.addEventListener('click', () => {
        const open = summaryEl.dataset.open === 'true';
        summaryEl.dataset.open = open ? 'false' : 'true';
        summaryToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    const filtersClear = root.querySelector('[data-filters-clear]');
    if (filtersClear) {
      filtersClear.addEventListener('click', () => {
        activeBrand = null;
        rebuildBrandFilter();
        applyBrandFilter();
      });
    }

    rebuildBrandFilter();
    updateLocks();
    renderSummary();

    const themeHeader = document.querySelector('store-header, .cc-header, header.section-header');
    const updateStickyOffset = () => {
      if (!themeHeader) {
        root.style.setProperty('--sb-sticky-offset', '0px');
        return;
      }
      const r = themeHeader.getBoundingClientRect();
      const bottom = Math.max(0, r.bottom);
      root.style.setProperty('--sb-sticky-offset', bottom + 'px');
    };
    updateStickyOffset();
    window.addEventListener('scroll', updateStickyOffset, { passive: true });
    window.addEventListener('resize', updateStickyOffset);
    // The header collapses with a transition that ends after the last scroll
    // event; without these the bars keep the taller offset and cards show
    // through the gap above them.
    if (themeHeader) {
      themeHeader.addEventListener('transitionend', updateStickyOffset);
      if (window.ResizeObserver) new ResizeObserver(updateStickyOffset).observe(themeHeader);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
